import { render, staticRenderFns } from "./help.vue?vue&type=template&id=6935deaf&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports